import React, { Component } from "react";
import {Helmet} from 'react-helmet'

class PageHelmet extends Component{
    render(){
        return(
            <React.Fragment>
                <Helmet>
                    <title>{this.props.pageTitle} ||| Welcome to Stardust LAB</title>
                    <meta name="description" content="Stardust LAB — independent contractor studio delivering design, language and publishing services on a project basis." />
                </Helmet>
            </React.Fragment>
        )
    }
}


export default PageHelmet;
